import { validateEvmAddress, validateSolAddress } from '@src/utils/addressUtils'

// Shortens blockchain addresses by showing only the start and end characters with an ellipsis in between
export const truncateAddress = (
    address: string,
    opts: {
        evmPrefixLen: number
        evmSuffixLen?: number
        solanaPrefixLen?: number
        solanaSuffixLen?: number
        tronPrefixLen?: number
        tronSuffixLen?: number
        btcPrefixLen?: number
        btcSuffixLen?: number
    } = {
        evmPrefixLen: 4,
        evmSuffixLen: 4,
        solanaPrefixLen: 5,
        solanaSuffixLen: 6,
        tronPrefixLen: 4,
        tronSuffixLen: 4,
        btcPrefixLen: 6,
        btcSuffixLen: 4,
    }
) => {
    if (!address || address === '') return 'No Account'

    // Match Ethereum-style addresses (0x...)
    const ethMatch = validateEvmAddress(address)
    if (ethMatch) {
        // remove the leading 0x
        address = address.slice(2)
        return `0x${address.slice(0, opts.evmPrefixLen!)}…${address.slice(address.length - opts.evmSuffixLen!)}`
    }

    // Match Solana-style addresses (Base58 string)
    const solMatch = validateSolAddress(address)
    if (solMatch)
        return `${address.slice(0, opts.solanaPrefixLen!)}…${address.slice(address.length - opts.solanaSuffixLen!)}`

    // Match TRON-style addresses (Base58 string starting with 'T')
    const tronMatch = address.match(
        new RegExp(`^(T[a-zA-Z0-9]{${opts.tronPrefixLen}})[a-zA-Z0-9]+([a-zA-Z0-9]{${opts.tronSuffixLen}})$`)
    )
    if (tronMatch) return `${tronMatch[1]}…${tronMatch[2]}`

    // Match Bitcoin-style addresses (bc1... or 1... or 3...)
    const btcMatch = address.match(/^[13][a-km-zA-HJ-NP-Z1-9]{25,34}$|^[(bc1q)|(bc1p)][0-9A-Za-z]{37,62}$/)
    if (btcMatch) {
        const prefix = btcMatch[1]
        const prefixLen = prefix === 'bc1' ? prefix.length + (opts.btcPrefixLen || 4) : opts.btcPrefixLen || 4
        const suffixLen = opts.btcSuffixLen || 4

        if (address.length <= prefixLen + suffixLen) {
            return address
        }

        return `${address.slice(0, prefixLen)}…${address.slice(-suffixLen)}`
    }

    // If address already contains '...', return as is
    if (address.includes('...')) return address
    // Otherwise truncate if long enough
    return address.length > 8 ? `${address.slice(0, 4)}…${address.slice(-4)}` : address
}
